import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import {
  RemoveBuyDocument,
  CreateExchangesDocument,
  UpdateBuyDocument,
  SearchBuyDocument,
  SearchBuyProductDocument,
  CreateBuyMovDocument,
  BuyMovFragmentDoc,
} from './schema.graphql';
import {
  GetAllBuyQueryVariables,
  GetAllBuyQuery,
  RemoveExchangesMutation,
  RemoveExchangesMutationVariable,
  CreateExchangesMutation,
  CreateExchangesMutationVariable,
  UpdateBuyMutation,
  UpdateBuyMutationVariable,
  SearchBuyQuery,
  SearchBuyQueryVariables,
  SearchBuyProductQueryVariables,
  SearchBuyProductQuery,
  CreateBuyMovMutation,
  CreateBuyMovMutationVariables,
} from 'src/app/model/buy';

@Injectable({
  providedIn: 'root',
})
export class CreateExchangesGQL extends Apollo.Mutation<
  CreateExchangesMutation,
  CreateExchangesMutationVariable
> {
  document = CreateExchangesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class GetAllBuyGQL extends Apollo.Query<
  GetAllBuyQuery,
  GetAllBuyQueryVariables
> {
  document = BuyMovFragmentDoc;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class CreateBuyMovGQL extends Apollo.Mutation<
  CreateBuyMovMutation,
  CreateBuyMovMutationVariables
> {
  document = CreateBuyMovDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class UpdateBuyGQL extends Apollo.Mutation<
  UpdateBuyMutation,
  UpdateBuyMutationVariable
> {
  document = UpdateBuyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SearchBuyGQL extends Apollo.Query<
  SearchBuyQuery,
  SearchBuyQueryVariables
> {
  document = SearchBuyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SearchBuyProductGQL extends Apollo.Query<
  SearchBuyProductQuery,
  SearchBuyProductQueryVariables
> {
  document = SearchBuyProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class RemoveExchangesGQL extends Apollo.Mutation<
  RemoveExchangesMutation,
  RemoveExchangesMutationVariable
> {
  document = RemoveBuyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
